import styled, { css } from 'styled-components';
import { Chip } from 'react-rainbow-components';
import { color } from 'theme';

export const ValueContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    outline: none;
    cursor: pointer;

    &:hover,
    &:focus {
        outline: 0;
    }
`;

export const InnerContainer = styled.div`
    position: relative;
    display: flex;
`;

export const StyledChip = styled(Chip)<{ $variant?: 'default' | 'inline' }>`
    background-color: ${color('background.main')};
    padding: ${({ $variant }) => ($variant === 'inline' ? '0.25rem 0.375rem 0.25rem 0.5rem' : '0.4375rem 0.625rem 0.4375rem 0.75rem')};
    align-items: center;
    gap: 0.5rem;
    flex: 1 1 auto;
    height: ${({ $variant }) => ($variant === 'inline' ? '2rem' : '3.375rem')};
    border: ${({ $variant }) => ($variant === 'inline' ? 'none' : undefined)};

    & > button[data-id="button-icon-element"] {
        margin-right: -0.3rem;
        border-radius: 0.375rem;

        &:hover {
            margin-right: -0.3rem;
            border-radius: 0.375rem;
        }
    }

    ${({ $variant }) => $variant === 'inline' && css`
        & > button[data-id="button-icon-element"] {
            opacity: 0;
            pointer-events: none;
            transition: opacity 120ms ease-in-out;
        }

        &:hover > button[data-id="button-icon-element"] {
            opacity: 1;
            pointer-events: auto;
        }
    `}
`;
